import { render, staticRenderFns } from "./goBuckreupCB.vue?vue&type=template&id=445ac712"
import script from "./goBuckreupCB.vue?vue&type=script&lang=js"
export * from "./goBuckreupCB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports